import { createGlobalStyle } from 'styled-components';
import { theme } from 'constants/styled-theme';

const GlobalStyle = createGlobalStyle`

.registrationPaymentFaildModal {
    .ReactModal__Content {  
      width: 770px;
      height: 257px;
      padding-top: 91px;
      @media (max-width: 999px) {
        width: 300px;
        padding: 50px 8px;
        height: auto;
      }
    }
  }

.registrationPaymentFormModal {
    .ReactModal__Content {  
      width: 770px;
      height: 500px;
    }
  }

  .confirmAndCheckoutNotSuccessModal {
    .ReactModal__Content {
      @media (max-width: 999px) {
        padding: 40px 8px;
      }
    }
  }

  .subscriptionAssociatedModal {
    .ReactModal__Content {
      width: 675px;
      @media (max-width: 999px) {
        width: 350px;
        padding: 40px 8px;
      }
    }
}

  .additionalPlansModal {
    .ReactModal__Content {
      width: 930px;
      height: auto;
      @media (max-width: 999px) {
        z-index: 9999999 !important;
        width: 95vw !important;
        max-width: 540px !important;
        margin: 20px auto !important;
      }
    }
}

.ReactModal__Overlay.modalOverlay {
    background: rgba(0, 0, 0, 0.4);
}

`;

export default GlobalStyle;
